<div class="module-cards-container">
	<div class="row module-cards-grid">
		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient1"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/audits-assessments.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient1
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient1
								"
								>Audits and Assessments
							</strong>
							<p class="mt-2">
								As processes, people, and tools change over
								time,
								<br class="d-none d-sm-block" />
								companies are exposed to potential compliance
								<br class="d-none d-sm-block" />
								risks. Schedule and track audits to ensure that
								your
								<br class="d-none d-sm-block" />
								compliance posture remains robust.
							</p>
						</div>

						<a [routerLink]="['/documentation/assessments']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient2"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/issues.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient2
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient2
								"
								>Issues / Plan of Action and
								<br class="d-none d-sm-block" />
								Milestones (POAMs)
							</strong>
							<p class="mt-2">
								Document Issues in real time and manage in
								 <br class="d-none d-sm-block" />
								RegScale and/or your ticketing system of choice
								(e.g. <br class="d-none d-sm-block" />
								JIRA or ServiceNow). We help your team
								proactively <br class="d-none d-sm-block" />
								identify non-compliances, assign corrective
								actions, <br class="d-none d-sm-block" />
								and track issues to closure.
							</p>
						</div>

						<a [routerLink]="['/documentation/issues']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient3"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/security-controls.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient3
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient3
								"
								>Security Controls
							</strong>
							<p class="mt-2">
								Define your controls. Document your controls.<br
									class="d-none d-sm-block"
								/>
								Implement your controls. Test your controls. All
								in <br class="d-none d-sm-block" />one place.
								Reduce risk, avoid cyber breaches and<br
									class="d-none d-sm-block"
								/>
								associated reputation loss, and allow for
								continuous<br class="d-none d-sm-block" />
								improvement of your cyber program with
								real-time<br class="d-none d-sm-block" />
								control.
							</p>
						</div>

						<a [routerLink]="['/documentation/securitycontrols']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient4"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/security-profiles.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient4
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient4
								"
								>Security Profiles
							</strong>
							<p class="mt-2">
								Create a baseline for compliance by easily
								assigning a <br class="d-none d-sm-block" />
								collection of security controls from multiple
								<br class="d-none d-sm-block" />
								regulations to a profile. Govern your related
								<br class="d-none d-sm-block" />
								compliance data such as security plans, policies, projects,
								and <br class="d-none d-sm-block" />
								supply chain contracts against a consistent security
								profile.
							</p>
						</div>

						<a [routerLink]="['/documentation/securityprofiles']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient2"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/tasks.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient2
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient2
								"
								>Tasks
							</strong>
							<p class="mt-2">
								Drive accountability around task management and
								<br class="d-none d-sm-block" />
								improve transparency on progress with
								<br class="d-none d-sm-block" />
								assignments, due dates, and recurring options.
							</p>
						</div>

						<a [routerLink]="['/documentation/tasks']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<div
					class="regscale-works-circle module-cards-linear-gradient1"
				>
					<div class="regscale-works-inner-circle">
						<img
							width="40px"
							src="../../assets/img/risks.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient1
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient1
								"
								>Risks
							</strong>
							<p class="mt-2">
								Plan for the worst by documenting and
								<br class="d-none d-sm-block" />
								developing effective mitigation strategies to
								<br class="d-none d-sm-block" />
								protect your organization.
							</p>
						</div>

						<a [routerLink]="['/documentation/risks']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="cards-collapse">
		<div class="row module-cards-grid mb-5">
			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient1
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/assets.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>Assets
								</strong>
								<p class="mt-2">
									Build out your security plan by tracking
									your <br class="d-none d-sm-block" />
									organization’s inventory of assets across
									their <br class="d-none d-sm-block" />
									entire lifecycle.
								</p>
							</div>

							<a [routerLink]="['/documentation/assets']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient2
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/casual-analysis.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Causal Analysis
								</strong>
								<p class="mt-2">
									Drive genuine performance improvement and
									<br class="d-none d-sm-block" />
									continuous improvement with rigorous causal
									<br class="d-none d-sm-block" />
									analysis processes.
								</p>
							</div>

							<a [routerLink]="['/documentation/causalanalysis']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient2
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/incidents.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Incidents
								</strong>
								<p class="mt-2">
									Get back to normal operations faster by
									securely <br class="d-none d-sm-block" />
									responding to cyber, safety, or
									security-related
									<br class="d-none d-sm-block" />
									incidents in a safe and collaborative
									environment.
								</p>
							</div>

							<a [routerLink]="['/documentation/incidents']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient3
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/policies.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Policies
								</strong>
								<p class="mt-2">
									Manage your policy lifecycle and reduce
									confusion <br class="d-none d-sm-block" />
									by defining organization rules and
									expectations with
									<br class="d-none d-sm-block" />
									digital documentation.
								</p>
							</div>

							<a [routerLink]="['/documentation/policies']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient3
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/interconnections.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Interconnections
								</strong>
								<p class="mt-2">
									Reduce risk with more oversight of your
									data, less <br class="d-none d-sm-block" />
									leakage, and easier data exchanges by
									securely <br class="d-none d-sm-block" />
									sharing data between applications and
									systems
								</p>
							</div>

							<a
								[routerLink]="[
									'/documentation/interconnections'
								]"
							>
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient4
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/projects.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Projects
								</strong>
								<p class="mt-2">
									Improve accountability by tracking
									requirements,
									<br class="d-none d-sm-block" />
									costs, milestones, issues, and risks to
									improve your
									<br class="d-none d-sm-block" />
									overall portfolio management.
								</p>
							</div>

							<a [routerLink]="['/documentation/projects']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient2
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/supply-chain.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Supply Chain
								</strong>
								<p class="mt-2">
									Mitigate third-party risks while working
									with <br class="d-none d-sm-block" />
									subcontractors and suppliers with custom
									flow <br class="d-none d-sm-block" />
									down requirements.
								</p>
							</div>

							<a [routerLink]="['/documentation/supplychain']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<div
						class="
							regscale-works-circle
							module-cards-linear-gradient3
						"
					>
						<div class="regscale-works-inner-circle">
							<img
								width="40px"
								src="../../assets/img/threats.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Threats
								</strong>
								<p class="mt-2">
									Put cyber defenders on the offensive and
									manage <br class="d-none d-sm-block" />
									your response to new and emerging threats in
									real- <br class="d-none d-sm-block" />time
									with third-party partners.
								</p>
							</div>

							<a [routerLink]="['/documentation/threats']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="mt-5">
		<button
			(click)="toggleCollapse()"
			id="full-list"
			class="shift-compliance-btn bg-white py-2 px-5 m-auto"
		>
			Check Out Our Full List
		</button>
		<button
			(click)="toggleCollapse()"
			id="see-less"
			class="shift-compliance-btn bg-white py-2 px-5 m-auto"
		>
			See less
		</button>
	</div>
</div>
